import { onBeforeMount, onBeforeUnmount, readonly, type Ref, ref } from 'vue'

export const useMediaDevices = (): Readonly<Ref<readonly MediaDeviceInfo[] | undefined>> => {
  const mediaDevices = ref<MediaDeviceInfo[] | undefined>(undefined)

  const updateMediaDevices = async (): Promise<void> => {
    mediaDevices.value = await navigator.mediaDevices.enumerateDevices()
  }

  onBeforeMount(() => {
    const devices = navigator.mediaDevices
    updateMediaDevices()
    devices.addEventListener('devicechange', updateMediaDevices)

    onBeforeUnmount(() => devices.removeEventListener('devicechange', updateMediaDevices))
  })

  return readonly(mediaDevices)
}
